import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AgentCardDto, SearchAgentCardDataDto } from '@workspace/data-types';

export type VirtualCardData = Partial<AgentCardDto & SearchAgentCardDataDto>;

@Component({
  selector: 'etxe-agent-card-display',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './agent-card-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentCardDisplayComponent {
  card = input<VirtualCardData | null>(null);
  isExpired = input<boolean>(false);
  isFlipped = signal(false);

  readonly isCardExpired = computed(() => {
    if (this.isExpired()) return true;
    const c = this.card();
    if (!c) return false;
    if (c.isActive === false) return true;
    if (c.expiresAt && new Date(c.expiresAt).getTime() < Date.now()) return true;
    return false;
  });

  toggleFlip() {
    this.isFlipped.update((v) => !v);
  }
}
